import { varietyState } from '@/app/model/store/domain/types'

export default {
  setSearchText (state: varietyState, payload: string) {
    state.searchText = payload
  },

  setOrderNum (state: any, num: number) {
    state.orderNum = num
  },

  setSort (state: any, sort: string) {
    state.sort = sort
  }
}
